import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_MODULES_REQUEST = "GET_MODULES_REQUEST";
export const GET_MODULES_SUCCESS = "GET_MODULES_SUCCESS";
export const GET_MODULES_ERROR = "GET_MODULES_ERROR";

//* ACTIONS ------------------------------------------------
export const getModulesRequest = (payload = {}, callback) => ({
  type: GET_MODULES_REQUEST,
  payload,
  callback,
});

export const getModulesSuccess = (data) => ({
  type: GET_MODULES_SUCCESS,
  payload: data,
});

export const getModulesError = (error) => ({
  type: GET_MODULES_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getModulesServiceRequest = async (params = {}) => {
  const options = await withToken({
    method: Methods.GET,
    params,
    headers: { CompanyId: await getUserCompany() },
  });

  return request(`/modules/get_modules`, options);
};
